import React from 'react'
import Block from '../block'
import { RichText } from '../richTextOptions'
import { Image } from '../BlockLibrary/Common/Image';

const ContentfulBlockCta = cta => {
  let classLayout = "";
  if (cta.ctaLayout && cta.ctaLayout !== 'Default') {
    classLayout = cta.ctaLayout.toLowerCase().replace(" ", "-")
  }
  return (
    <>
      <div className={`cta ${classLayout}`}>
        {
          cta.topImage && !cta.centerImage && (
            <div className="image-wrap">
              <Image image={cta.topImage} />
            </div>
          )
        }
        {cta.shortDescription && (
          <RichText data={cta.shortDescription}></RichText>
        )}
        {
          cta.centerImage && !cta.topImage && (
            <div className="image-wrap">
              <Image image={cta.centerImage} />
            </div>
          )
        }
        {
          cta.ctaButton || cta.ctaLink ? (
            <div className="cta-button-center">
              {cta.ctaButton && <Block block={cta.ctaButton}></Block>}
              {cta.ctaLink && <div className="cta-link"><Block block={cta.ctaLink}></Block></div>}
            </div>
          ) : (<></>)
        }
      </div>
    </>
  )
}

export { ContentfulBlockCta }
